import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getUtmParams } from '@/lib/attribution';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Pageview for per-page conversion rates (RGPD-friendly, no cookies)
const trackPageview = () => {
  try {
    const utmParams = getUtmParams();
    const body = JSON.stringify({
      page: window.location.pathname,
      landing_url: utmParams.landing_url || window.location.href,
      keyword: utmParams.keyword || '',
      source: '',
      referrer: utmParams.referrer || document.referrer || '',
      gclid: utmParams.gclid || '',
      utm_source: utmParams.utm_source || '',
      utm_medium: utmParams.utm_medium || ''
    });
    const url = `${API}/track/pageview`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    }
  } catch (e) {}
};

export const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageview();
  }, [location.pathname]);
};
